export const IG_LINK= "https://instagram.com/the_island_festival?igshid=YmMyMTA2M2Y="

export const TIKTOK_LINK = "https://www.tiktok.com/@theisland_people?_r=1&_t=ZN-95B86hYifhe"

export const BOOK_EXPERIENCE_LINK = "https://www.eventbrite.com/cc/the-island-fuze-tea-2026-4847813"